import type { InfluencerWeb } from '@/plugins/influencer';
import type { InjectionKey } from 'vue';

export const injectionKeys = {
	/**
	 * The Influencer Web API client
	 */
	INFLUENCER: Symbol('influencer') as InjectionKey<InfluencerWeb>,
} as const;
